import {Route} from "../../../common/enums/route";

// TODO: make this actually work
// interface IRequiredPermission {
//   name: string;
//   param: string;
// }
//
// interface IBookmarkBuilderConfig {
//   displayName?: string;
//   route?: Route;
//   children?: IBookmarkBuilderConfig[];
//   search?: string;
//   textInput?: boolean;
//   requiredPermission?: IRequiredPermission;
// }

// every a-selectable node _must_ have a displayName

// for requiredPermission, not all Cans are loaded; check bookmarkLinkBuilderInterfaceStoreHelper

// if you need to remember which configs were chosen to a route duplicated somewhere else in a tree,
// add something like a 'builderConfigId' with different values on the builder configs with the duplicated routes,
// and store that in BookmarkLink alongside 'route'

const hyperLinkConfig = {
  displayName: 'Hyperlink',
  children: [
    {
      textInput: true,
    }
  ]
};

const dashboardsConfig = {
  displayName: 'Dashboards',
  children: [
    {
      displayName: 'My Dashboard',
      route: Route.dashboard,
    },
    {
      displayName: 'My Actions',
      children: [
        {
          displayName: 'All Actions',
          route: Route.actionsDashboard,
          default: true,
        },
        {
          displayName: 'Pending Actions',
          route: Route.pendingActionsActionsDashboard,
        },
        {
          displayName: 'Pending Assignments',
          route: Route.pendingAssignmentsActionsDashboard,
        },
        {
          displayName: 'Previously Reviewed Applications',
          route: Route.previouslyReviewedSubmissionsActionsDashboard,
        },
      ]
    },
    {
      displayName: 'My Submissions',
      route: Route.submissionsDashboard
    },
  ]
};

const reportingAndSubmissionsConfig = {
  displayName: 'Reporting & Submissions',
  requiredPermission: {name: 'viewReportingDashboard', param: 'user'},
  children: [
    {
      displayName: 'Forms',
      route: Route.formsAnalystDashboard,
      default: true,
      children: [
        {
          instanceObjectSelect: 'Form',
          searchType: 'analystDashboardForms',
          children: [
            {
              displayName: 'List View',
              route: Route.formAnalystDashboardListView,
            },
            {
              displayName: 'Summary View',
              route: Route.formAnalystDashboardSummaryView,
            }
          ]
        }
      ]
    },
    {
      displayName: 'All Submissions',
      route: Route.submissionsAnalystDashboard,
    },
  ]
};

const documentFoldersConfig = {
  displayName: 'Document Folders',
  children: [
    {
      instanceObjectSelect: 'Folder',
      route: Route.manageDocuments,
      requiredPermission: {name: 'selectFolder', param: 'organization'},
    }
  ]
};

const mainPagesConfig = {
  displayName: 'Main Pages',
  children: [
    dashboardsConfig,
    {
      displayName: 'Manage Members',
      requiredPermission: {name: 'viewOrganizationManagement', param: 'user'},
      children: [
        {
          displayName: 'Members',
          requiredPermission: {name: 'manageMembersOrRoles', param: 'organization'},
          route: Route.organizationMemberships,
        },
        {
          displayName: 'Groups',
          requiredPermission: {name: 'viewGroupsArea', param: 'organization'},
          route: Route.organizationGroups,
        },
        {
          displayName: 'Role Management',
          requiredPermission: {name: 'manageRoles', param: 'organization'},
          route: Route.organizationRoles,
        },
      ]
    },
    {
      displayName: 'Manage Documents',
      children: documentFoldersConfig.children,
    },
    {
      displayName: 'Manage Portals',
      route: Route.portals,
      requiredPermission: {name: 'viewPortalManagement', param: 'user'},
      children: [
        {
          instanceObjectSelect: 'Portal',
          route: Route.editPortal,
        }
      ]
    },
    {
      displayName: 'Organization Settings',
      requiredPermission: {name: 'manageSettings', param: 'organization'},
      children: [
        {
          displayName: 'Organization Info',
          route: Route.organizationSettingsInfo,
        },
        {
          displayName: 'Branding',
          route: Route.organizationSettingsBranding,
        },
        {
          displayName: 'Templates',
          route: Route.organizationSettingsTemplates,
          requiredPermission: {name: 'manageTemplates', param: 'organization'},
        },
        {
          displayName: 'Preferences',
          route: Route.organizationSettingsPreferences,
        },
        {
          displayName: 'Billing',
          route: Route.organizationSettingsBilling,
        },
        {
          displayName: 'Connections',
          route: Route.organizationSettingsConnections,
          requiredPermission: {name: 'manageConnections', param: 'organization'},
        },
        {
          displayName: 'Profiles',
          route: Route.organizationSettingsProfiles,
          requiredPermission: {name: 'manageProfiles', param: 'organization'},
        },
      ]
    },
    {
      displayName: 'Personal Settings',
      children: [
        {
          displayName: 'Profile',
          route: Route.accountProfile,
        },
        {
          displayName: 'Security',
          route: Route.accountSecurity,
        },
        // {
        //   displayName: 'Themes',
        //   route: Route.accountThemes,
        // },
      ]
    },
    reportingAndSubmissionsConfig,
  ]
};

const config = {
  children: [
    hyperLinkConfig,
    dashboardsConfig,
    reportingAndSubmissionsConfig,
    mainPagesConfig,
    documentFoldersConfig,
  ]
};

export default config;
